import { useAuth } from "~/store/auth";
import api from "../auth/api";
import { useSettings } from "~/store/settings";

export default async function initialiseAuth() {
	const auth = useAuth();
	const { $trackEvent, $messageHandler, $initBannerTags } = useNuxtApp();
	const authToken = useCookie("betway-auth");
	const { isTokenNearExpiry } = useSessionAuth();
	const authRefreshToken = useCookie("betway-refresh-token");
	const store = useSettings();

	let isNewSession: boolean;
	try {
		isNewSession = await $initBannerTags();
	} catch (e) {
		isNewSession = false;
	}
	if (authToken.value && authRefreshToken.value && store.autoLogin === true) {
		await auth.login(authToken.value as string, authRefreshToken.value as string);
		if (authToken.value && isTokenNearExpiry(authToken.value)) {
			api<{ access_token: string; refresh_token: string }>({
				url: "/Users/refresh-token",
				type: "auth",
				options: { method: "POST" },
				data: {
					refresh_token: authRefreshToken.value,
				},
			})
				.then((res) => {
					auth.token = res.access_token;
					auth.refresh_token = res.refresh_token;
					setWildCardCookie("betway-auth", res.access_token, 7);
					setWildCardCookie("betway-refresh-token", res.refresh_token, 7);
					return res;
				})
				.catch(() => auth.logout());
		}

		if (!store.isDataFree) auth.updateBalance();

		if (isNewSession === true && auth.profile) {
			$trackEvent.loginComplete(formatMobile(auth.profile.username));
		}
	} else {
		auth.hydrated = true;
	}
	$messageHandler({
		message: "Ready",
		data: { ready: true, isLoggedIn: auth?.loggedIn },
	});

	$messageHandler({
		message: "maintenance",
		data: { maintenance: false },
	});
	
	$messageHandler({
		message: "Login",
		data: {
			login: auth?.loggedIn,
			PlayerId: auth?.loggedIn ? auth?.profile?.id : "",
			setLang: useSettings().locale,
			token: auth?.loggedIn ? `Bearer ${auth.token}` : "",
		},
	});
}
